// Node modules
import React from 'react';
import { nanoid } from 'nanoid';
import { RichText } from 'prismic-reactjs';

import ContactInformationItem from './ContactInformationItem';

import theme from '@/themes/index';

const ContactInformation = ({
  content,
}) => (
  <>
    {content.map(({
      contactItem: {
        title,
        items,
        officeHours,
      },
    }, index) => (
      <React.Fragment key={nanoid()}>
        <div className="contact-information-container">
          <h5>{title}</h5>
          <div className="contact-information-container-item">
            {items.map(({
              item,
            }) => <ContactInformationItem key={nanoid()} content={item} />)}
          </div>
          {officeHours && <div className="office-hours">
            <RichText render={officeHours} />
          </div>}
        </div>
        {index + 1 !== content.length && <hr />}
      </React.Fragment>
    ))}
    <style jsx>{`
      hr {
        margin-block-start: 0;
        margin-block-end: 0;
      }

      .contact-information-container {
        margin-top: 4rem;
        margin-bottom: 2rem;
      }

      .contact-information-container h5 {
        line-height: 2rem;
        color: ${theme.fontColors.optional4};
      }

      .contact-information-container-item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }

      @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
        div.contact-information-container-item {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
        }
      }

      @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
        .contact-information-container-item {
          display: flex;
          flex-direction: row;
          width: 100%;
        }

        .contact-information-container h5 {
          margin-top: 3.5rem;
        }
      }
    `}</style>
    <style global jsx>{`
      div.contact-information-container div.office-hours p {
        line-height: 1.875rem;
        margin-block-start: 0;
        margin-block-end: 0;
      }
    `}</style>
  </>
);

export default ContactInformation;